/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricerules_Mock_Rule1_CondInputs */

const tr_landing_pricerules_mock_rule1_cond = /** @type {(inputs: Landing_Pricerules_Mock_Rule1_CondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`USD %1 artarsa`)
};

const en_landing_pricerules_mock_rule1_cond = /** @type {(inputs: Landing_Pricerules_Mock_Rule1_CondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`USD rises 1%`)
};

const de_landing_pricerules_mock_rule1_cond = /** @type {(inputs: Landing_Pricerules_Mock_Rule1_CondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`USD steigt um 1%`)
};

const ru_landing_pricerules_mock_rule1_cond = /** @type {(inputs: Landing_Pricerules_Mock_Rule1_CondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`USD растет на 1%`)
};

/**
* | output |
* | --- |
* | "USD rises 1%" |
*
* @param {Landing_Pricerules_Mock_Rule1_CondInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_pricerules_mock_rule1_cond = /** @type {((inputs?: Landing_Pricerules_Mock_Rule1_CondInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricerules_Mock_Rule1_CondInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricerules_mock_rule1_cond(inputs)
	if (locale === "de") return de_landing_pricerules_mock_rule1_cond(inputs)
	if (locale === "ru") return ru_landing_pricerules_mock_rule1_cond(inputs)
	return tr_landing_pricerules_mock_rule1_cond(inputs)
});